export const NumericKeyCodesEnum = {
  48: '0', //0
  49: '1', //1
  50: '2', //2
  51: '3', //3
  52: '4', //4
  53: '5', //5
  54: '6', //6
  55: '7', //7
  56: '8', //8
  57: '9', //9
  96: '0', //numpad 0
  97: '1', //numpad 1
  98: '2', //numpad 2
  99: '3', //numpad 3
  100: '4', //numpad 4
  101: '5', //numpad 5
  102: '6', //numpad 6
  103: '7', //numpad 7
  104: '8', //numpad 8
  105: '9', //numpad 9
};
